import React from "react";
import Typist from 'react-typist';
import 'react-typist/dist/Typist.css'
import messages from '../components/messages';
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import first from "../assets/images/BSc/1.png";
import second from "../assets/images/BSc/2.png";
import third from "../assets/images/BSc/3.png";
import fourth from "../assets/images/BSc/4.png";
import ResponsiveEmbed from "react-responsive-embed";


const Index = props => {
  return (
      <div className="c-content-box">
        <h2>Tesi di laurea triennale</h2>
          <div style={{ textAlign: 'justify', lineHeight: '2em'}}>

          <img src={first} style={{ width: '100%', height: '100%' }} />

          <h3>Generalità</h3>
          Il presente lavoro di tesi è incentrato sullo studio del comportamento meccanico, con particolare riferimento alla resistenza a taglio, di calcestruzzi la cui composizione è ottenuta effettuando una sostituzione di parte degli aggregati grossi con aggregati derivanti dal riciclo di rifiuti da costruzione e demolizione di manufatti edili e/o civili. <br /> <br />

          <img src={second} style={{ width: '100%', height: '100%' }} />

          <h3>Dettagli del lavoro</h3>
          Questi studi sono basati su prove di laboratorio su provini cubici, cilindrici e infine travetti in calcestruzzo armato. E’ stato studiato il campo di applicazione di questo tipo di aggregato sia in Italia che a livello europeo e mondiale. E’ presentato uno stato dell’arte dettagliato relativo al mix design di calcestruzzi realizzati tramite l’impiego di aggregati derivanti dal riciclo. Nel capitolo 4 è inoltre descritto lo stato dell’arte relativo al comportamento a taglio delle strutture in calcestruzzo armato con particolare riferimento alla “Modified Compression Field Theory” di Frank J. Vecchio e Michael P. Collins. Infine si è studiato un modello agli elementi finiti con il software “Response2000” volto a valutare lo stato tensionale presente nei travetti durante la prova di flessione-taglio. <br /> <br />

                                                                                                              <ResponsiveEmbed src='https://www.youtube.com/embed/bgeHvoaSNec' allowFullScreen /><br /><br />
          <img src={third} style={{ width: '100%', height: '100%' }} />

          <h3>Risultati principali</h3>
          Il presente studio ha consentito di evidenziare comportamenti che la classica teoria MCFT non è in grado di cogliere con esattezza e che possono rappresentare la base per futuri approfondimenti nello stesso settore di ricerca. <br /> <br />

          <img src={fourth} style={{ width: '100%', height: '100%' }} />
        </div>
      </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/bachelor.it.jsx